import LinkAccount from 'src/features/auth/components/LinkAccount';
import { useAuth } from 'src/features/auth/contexts/AuthContext';

export default function LinkAccountPage() {
  const { user } = useAuth();
  return <LinkAccount email={user?.email} redirectUrl="/plugins/outlook/login" className="w-full" />;
}
